import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

export default function SidebarSubsection({
  title,
  open,
  onToggle,
  className = "",
  children,
}) {
  if (!children) return null;

  return (
    <div className={`new-sidebar-subsection ${open ? "is-open" : ""} ${className}`}>
      {title ? (
        <button
          type="button"
          className="new-sidebar-subsection__trigger"
          aria-expanded={open}
          onClick={onToggle}
        >
          <span className="new-sidebar-subsection__title">{title}</span>
          <span className="new-sidebar-subsection__chevron" aria-hidden="true">
            <FontAwesomeIcon icon={faChevronDown} />
          </span>
        </button>
      ) : null}
      <div className="new-sidebar-subsection__items">{children}</div>
    </div>
  );
}
